import { Scope } from './interface'
import { store } from '../../stateManager';

export default function a8data(scope: Scope) {

    const state = store.getState()
    const appType = state.apps.selectedApp.type

    return (appType === 'a8solo' || appType === 'a8chat') ?
        `
        interface Operations {
            find: (query?: Object) => Promise<any>;
            insert: (document: Object) => Promise<any>;
            insertMany: (document: Object[]) => Promise<any>;
            update: (document: Object, documentId: number) => Promise<any>;
            delete: (documentId: number) => Promise<any>;
            batchOperation:  (operations: BatchOperation[]) => Promise<any>;
        };
        
        type getAppFn = (appId: string) => Promise<{
            [key: string]: Operations
        }>;
        
        declare var a8data:{
            getApp: getAppFn;
            [key: string]: Operations;
        };
    `
        :
        `
        interface Operations {
            find: (query?: Object) => Promise<any>;
            insert: (document: Object) => Promise<any>;
            insertMany: (document: Object[]) => Promise<any>;
            update: (document: Object, documentId: number) => Promise<any>;
            delete: (documentId: number) => Promise<any>;
            batchOperation:  (operations: BatchOperation[]) => Promise<any>;
        };

        type getAppFn = (appId: string) => Promise<{
            [key: string]: Operations
        }>;

        interface Filter {
            id?: number,
            query?: object
        }
        
        interface Transactions {
            filter?: Filter,
            document?: object
        }
        
        interface BatchOperation {
            operation: string,
            transactions: Transactions[]
        }
        
        declare var a8data:{
            getApp: getAppFn;
            [key: string]: Operations;
        };
    `
}
